import React, { useEffect, useRef, useState } from "react";
import { BsStopwatch } from "react-icons/bs";
import Tooltip from "../retro/tooltip/tooltip.component";
import "./duration.styles.scss";

const options = [
  ["00:05", "5m"],
  ["00:10", "10m"],
  ["00:15", "15m"],
  ["00:20", "20m"],
  ["00:25", "25m"],
  ["00:30", "30m"],
  ["00:45", "45m"],
  ["01:00", "1h"],
  ["01:15", "1h 15m"],
  ["01:30", "1h 30m"],
  ["02:00", "2h"],
  ["03:00", "3h"],
  ["04:00", "4h"],
];

export default function Duration({
  duration = "",
  setDuration,
  handleUpdateTaskDuration,
  disabled = false,
}) {
  const [showDuration, setShowDuration] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!showDuration) return;
    const closeOutside = (event) => {
      if (!rootRef.current?.contains(event.target)) setShowDuration(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setShowDuration(false);
    };
    document.addEventListener("pointerdown", closeOutside, true);
    document.addEventListener("focusin", closeOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOutside, true);
      document.removeEventListener("focusin", closeOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [showDuration]);

  return (
    <div className="tm__durationest" ref={rootRef}>
      <input
        value={duration ?? ""}
        onChange={(event) => setDuration(event.target.value)}
        placeholder="Duration est."
        aria-label="Duration estimate"
        disabled={disabled}
      />
      <button
        type="button"
        className="duration__trigger"
        onClick={() => setShowDuration(!showDuration)}
        aria-label="Choose duration estimate"
        aria-expanded={showDuration && !disabled}
        disabled={disabled}
      >
        <BsStopwatch size="1.3em" />
      </button>
      <Tooltip text="Duration Estimate" />
      {showDuration && !disabled && (
        <div
          className="duration__container"
          role="group"
          aria-label="Duration presets"
        >
          {options.map(([value, label]) => (
            <button
              type="button"
              className="duration__tag"
              key={value}
              onClick={() => {
                handleUpdateTaskDuration(value);
                setShowDuration(false);
              }}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
